import { Injectable } from "@angular/core";
import { ApiService } from "./api.service";
import { environment } from "../../../environments/environment";
import { Observable } from "rxjs";

@Injectable({
    providedIn: 'root'
})
export class PickingProductivityService {
    /**
      * Creates an instance of pick service.
      * @param apiService: ApiService
      */
    constructor(public apiService: ApiService) {
    }
    /**
     * Gets accumulated
     * @param params any
     * @returns Observable<any>
     */
    getAccumulated(params: any): Observable<any> {
        return this.apiService.get(`${environment.apiPicking}/leadTime`, params)
    }
    /**
     * Gets detail accumulated
     * @param params any
     * @returns Observable<any>
     */
    getDetailAccumulated(params: any): Observable<any> {
        return this.apiService.post(`${environment.apiPicking}/leadTime/detail`, params)
    }
}